import { DebounceInput } from 'react-debounce-input'
import { InputStyle } from '../../style/StyledElement'

export const InputField = ({
  name,
  useName,
  readOnly,
  placeholder,
  onChange,
  onBlur,
  inputRef,
  type,
  error,
}) => {
  const onChangeInput = (input) => {
    const value = input.target.value
    const name = input.target.name
    if (onChange) {
      if (useName) {
        onChange({ name, value })
      } else {
        onChange(value)
      }
    }
  }

  const onBlurInput = (input) => {
    if (onBlur) {
      const value = input.target.value
      const name = input.target.name
      onBlur({ name, value })
    }
  }

  return (
    <DebounceInput
      readOnly={readOnly}
      element={InputStyle}
      placeholder={placeholder}
      name={name}
      type={type}
      debounceTimeout={300}
      onChange={onChangeInput}
      onBlur={onBlurInput}
      height={60}
      style={{
        borderColor: error ? 'red' : 'grey',
      }}
      inputRef={inputRef}
    />
  )
}
